const locales: { [key: string]: string } = {
  GB: 'en-gb',
};

export default locales;
